import React, { FC, useMemo, useRef, MutableRefObject, CSSProperties } from 'react';
import { generateGuid } from 'utils/Guid';
import { Button } from 'components/buttons/Button/Button';

export interface IChooseFileProps {
  name?: string;
  isMultiFileUpload?: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  isDisabled?: boolean;
  linkCssClass?: string;
  tabIndex?: number;
  fontCssStyles?: CSSProperties;
}
export const ChooseFile: FC<IChooseFileProps> = props => {
  const id = useMemo(() => generateGuid(), []);
  const linkName = props.isMultiFileUpload ? 'Choose File(s)' : 'Choose a File';
  const linkRef: MutableRefObject<HTMLInputElement | null> = useRef(null);
  return (
    <div className="dp-file-upload-area__link-holder">
      <input
        id={id}
        multiple={props.isMultiFileUpload}
        style={{ display: 'none' }}
        type="file"
        onChange={props.onChange}
        ref={linkRef}
      />
      <span className="dp-file-upload-area__text">or</span>
      <label htmlFor={props.isDisabled ? '' : id}>
        <Button
          variant="link"
          name={props.name || linkName}
          disabled={props.isDisabled}
          className={`dp-file-upload-area__link ${props.linkCssClass || ''}`}
          fontSize={'small'}
          fontWeight={'bold'}
          onClick={() => {
            linkRef.current?.click();
          }}
          tabIndex={props.tabIndex}
          style={{ ...props.fontCssStyles, textTransform: 'initial' }}
        >
          {props.name || linkName}
        </Button>
      </label>
    </div>
  );
};
